// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__1hBI_","calendarButtons":"ClockData_calendarButtons__18KDH"};